import { ApolloClient, InMemoryCache, from } from "@apollo/client";
import { useRef } from "react";

import { getAuthLink, getHttpLink } from "./apollo-links";
import { getErrorLink } from "./apollo-links/getErrorLink";
import { getTelemetryLink } from "./apollo-links/getTelemetryLink";

const cache = new InMemoryCache();
export const useGetApolloClient = () => {
  // Singleton apollo client
  const clientRef = useRef(
    new ApolloClient({
      cache: cache,
      link: from([
        getTelemetryLink(),
        getErrorLink(),
        getAuthLink(),
        getHttpLink(),
      ]),
      name: "cerner-web-client",
      queryDeduplication: true,
      defaultOptions: {
        watchQuery: {
          fetchPolicy: "network-only",
        },
      },
    })
  );

  return clientRef.current;
};
